// Herkunft „aus dem Portal" ueber den stillen SSO-Sprung hinweg merken
// (Jans Fund 18.09.2026).
//
// Das Schliessen-X des Viewers (ViewerChrome.handleClose) entscheidet anhand
// von `document.referrer`, ob es eine echte Vorgaengerseite gibt (→ zurueck)
// oder ob es ein Direkt-Link war (→ Org-Homepage bzw. Plattform). Kommt ein
// ANGEMELDETER Nutzer aus dem Portal, haengt das Portal `?sso=1` an und der
// Viewer springt einmal still ueber Keycloak (prompt=none). Danach ist der
// Referrer leer (Keycloak sendet `Referrer-Policy: no-referrer`) — das X hielt
// den Besuch fuer einen Direkt-Link und schickte Jan auf die Homepage seiner
// Org (schwochow.de) statt zurueck zur Scrolly-Home. Anonym (kein Sprung) und
// bei Orgs ohne gepflegte Website fiel es nicht auf.
//
// Loesung: Beim ERSTEN Laden — der Referrer zeigt dann noch aufs Portal — die
// Herkunft im sessionStorage merken (pro Tab, ueberlebt den Roundtrip), an den
// Pfad gebunden, damit ein spaeter im selben Tab geoeffneter Direkt-Link nicht
// faelschlich als Portal-Besuch gilt.
import { PLATFORM_BASE_URL } from "./platform-urls";

const SCHLUESSEL = "scrolly:von-portal";

function portalOrigin(): string | null {
  try {
    return new URL(PLATFORM_BASE_URL).origin;
  } catch {
    return null;
  }
}

/** true, wenn `referrer` vom Portal stammt. Rein, fuer Tests. */
export function istPortalReferrer(referrer: string, portal: string | null = portalOrigin()): boolean {
  if (!referrer || !portal) return false;
  try {
    return new URL(referrer).origin === portal;
  } catch {
    return false;
  }
}

/** Beim Laden aufrufen (mehrfach unschaedlich): merkt die Portal-Herkunft fuer diesen Pfad. */
export function merkePortalHerkunft(): void {
  if (typeof window === "undefined") return;
  try {
    if (istPortalReferrer(document.referrer)) {
      window.sessionStorage.setItem(SCHLUESSEL, window.location.pathname);
    }
  } catch {
    /* sessionStorage gesperrt (Privatmodus/Einbettung) → dann eben altes Verhalten */
  }
}

/** Kam der Besuch dieses Scrollys aus dem Portal? */
export function kamAusDemPortal(): boolean {
  if (typeof window === "undefined") return false;
  try {
    return window.sessionStorage.getItem(SCHLUESSEL) === window.location.pathname;
  } catch {
    return false;
  }
}

/** Ziel fuers Schliessen, wenn der Besuch aus dem Portal kam. */
export const PORTAL_HOME_URL = `${PLATFORM_BASE_URL}/home`;
